import { formatDate } from '@lib/date'
import { useEffect, useRef, useState } from 'react'
import IconCalendar from '../Icons/Clendar'
import IconPlus from '../Icons/Plus'
import Button from '@global/Button'
import makeUrls from './helper'
import useClickOutside from '@hooks/useClickOutside'
import * as S from './AddToCalendar.styled'
import facebookPixel from '@lib/facebookPixelHelper'

const AddToCalendar = ({ property, tz, start, end, type, text, title }) => {
  const [open, setOpen] = useState(null)
  const [eventUrls, setEventUrls] = useState({})
  const addToCalendarRef = useRef(null)

  // format the date/time
  const timezone = tz || 'Australia/Melbourne'
  const startTime = start
    ? formatDate(new Date(start), 'EEEE d MMMM h:mmaaa', timezone)
    : null
  const endTime = end ? formatDate(new Date(end), 'h:mmaaa', timezone) : null

  // build the text label
  const label = `${startTime}${endTime ? ' - ' + endTime : ''}`

  useEffect(() => {
    const data = {
      name: title || type + ': ' + property.address || '',
      details: `${property.descTitle || property.headline} - https://${window.location.host
        }${property.get_absolute_url}`,
      location: property.address || '',
      startsAt: start,
      endsAt: end || start,
    }
    setEventUrls(start ? makeUrls(data) : null)
  }, [property, start, end])

  const toggleDropdown = () => setOpen((prev) => !prev)

  useClickOutside(addToCalendarRef, () => setOpen(false))

  return start && eventUrls ? (
    <S.AddToCalendar ref={addToCalendarRef}>
      <Button
        border
        size='sm'
        color='primary'
        startIcon={<IconPlus />}
        endIcon={<IconCalendar />}
        onClick={toggleDropdown}
      >
        <S.AddToCalendarLabel>{text || label}</S.AddToCalendarLabel>
      </Button>
      <S.AddToCalendarDropdown open={open}>
        {Object.keys(eventUrls).map((key) => (
          <S.AddToCalendarDropdownItem
            href={eventUrls[key]}
            key={key}
            filename={
              key === 'Apple' || key === 'Outlook' ? 'download' : undefined
            }
            target='_blank'
            rel='noopener noreferrer'
            onClick={() => {
              facebookPixel.trackSchedule(`${title} | ${label}`)
              if (window.dataLayer) {
                window.dataLayer.push({
                  event: 'add_to_calendar',
                  property_id: property.id,
                  type: type,
                  start: start,
                  end: end,
                })
              }
            }}
          >
            {key}
          </S.AddToCalendarDropdownItem>
        ))}
      </S.AddToCalendarDropdown>
    </S.AddToCalendar>
  ) : null
}

export default AddToCalendar
